import {
  scroller_styles_default
} from "./chunk.M3YQ3ZI6.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  e2,
  i,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/scroller/scroller.ts
var FadvScroller = class extends s {
  constructor() {
    super(...arguments);
    this.scrollStart = "top";
    this.mode = "opaque";
  }
  handleScrollChange() {
    requestAnimationFrame(() => {
      const hasScrollbar = this.hasScrollbar;
      if (!hasScrollbar) {
        this.handleMouseenter();
      }
      this.scrollableUp = this.scrollerRef.scrollTop > 0;
      this.scrollableDown = this.scrollerRef.scrollTop + this.scrollerRef.clientHeight < this.scrollerRef.scrollHeight;
      if (!hasScrollbar) {
        this.handleMouseleave();
      }
    });
  }
  firstUpdated() {
    this.handleScrollChange();
  }
  handleMouseenter() {
    if (this.scrollerTimeout) {
      clearTimeout(this.scrollerTimeout);
      this.scrollerTimeout = void 0;
    }
    this.hasScrollbar = true;
  }
  handleMouseleave() {
    this.scrollerTimeout = setTimeout(() => {
      this.hasScrollbar = false;
      this.scrollerTimeout = void 0;
    }, 1e3);
  }
  async handleSlotChange() {
    if (this.scrollStart === "bottom") {
      await this.updateComplete;
      setTimeout(() => {
        this.scrollerRef.scrollTop = this.scrollerRef.scrollHeight;
      });
    }
  }
  connectedCallback() {
    super.connectedCallback();
    this.resizeObserver = new ResizeObserver(() => this.handleScrollChange());
    this.updateComplete.then(() => {
      this.resizeObserver.observe(this);
      this.handleScrollChange();
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.resizeObserver.unobserve(this);
  }
  render() {
    return $`<div class=${o({
      scroller: true,
      "scroller--scrollable-down": this.scrollableDown,
      "scroller--scrollable-up": this.scrollableUp,
      "scroller--has-scrollbar": this.hasScrollbar,
      "scroller--transparent": this.mode === "transparent",
      "scroller--opaque": this.mode === "opaque"
    })} @mouseenter=${this.handleMouseenter} @mouseleave=${this.handleMouseleave} @touchstart=${this.handleMouseenter} @touchend=${this.handleMouseleave} ><div class="scroller__top-shadow"></div><div class="scroller__container" tabindex="0" @scroll=${this.handleScrollChange} @slotchange=${this.handleSlotChange}><slot></slot></div><div class="scroller__bottom-shadow"></div></div>`;
  }
};
FadvScroller.styles = scroller_styles_default;
__decorateClass([
  e()
], FadvScroller.prototype, "scrollStart", 2);
__decorateClass([
  e()
], FadvScroller.prototype, "mode", 2);
__decorateClass([
  t()
], FadvScroller.prototype, "scrollableDown", 2);
__decorateClass([
  t()
], FadvScroller.prototype, "scrollableUp", 2);
__decorateClass([
  t()
], FadvScroller.prototype, "hasScrollbar", 2);
__decorateClass([
  t()
], FadvScroller.prototype, "scrollerTimeout", 2);
__decorateClass([
  i(".scroller__container")
], FadvScroller.prototype, "scrollerRef", 2);
__decorateClass([
  e2({ passive: true })
], FadvScroller.prototype, "handleMouseenter", 1);
__decorateClass([
  e2({ passive: true })
], FadvScroller.prototype, "handleMouseleave", 1);
FadvScroller = __decorateClass([
  n("fadv-scroller")
], FadvScroller);

export {
  FadvScroller
};
